export default __webpack_public_path__ + "static/media/favorite_outline.2b6967b7.svg";